export const environment = {
  production: true,
  socketPrefix: `${window.location.protocol.replace('http', 'ws')}//${window.location.host}/socket`,
  apiPrefix: '/api/',
  about: {version: require('../../package.json').version, buildDate: 1791541967663}
};
